export default {
  addGroup: () => `/course-group`,
  updateGroup: () => `/course-group`,
  deleteGroup: groupId => `/course-group/${groupId}`,
  getGroups: () => `/course-group`,
};
